const mossgreen = {
  100: "#F5F7F3",
  200: "#EBEFE7",
  300: "#D7DFCF",
  400: "#D7DFCF",
  500: "#B0BFA0",
  600: "#9CAF88",
  700: "#7D8C6D",
  800: "#5E6952",
  900: "#3E4636",
  contrastDefaultColor: "#ffffff"
}

export default mossgreen
